import { defineComponent as _defineComponent } from 'vue'
import OfferRow from '@/features/buybox/components/grid/OfferRow.vue';
import LinearOffer from '@/features/buybox/components/grid/LinearOffer.vue';
// EXP_LINEAR_TV
import LinearOfferExp from '@/components/experiments/LinearTVExp/LinearOfferExp.vue';
// EXP_LINEAR_TV

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { LinearTitleOffer } from '@/interfaces/buybox';

interface LinearRowProps {
	title: TitleDetail;
	offers: LinearTitleOffer[];
	inline?: boolean;
	trackingContexts?: SnowplowContext[];
	// EXP_LINEAR_TV
	isLinearTVExp?: boolean;
	linearOffers?: LinearTitleOffer[];
	isBannerBuyBox?: boolean;
	// EXP_LINEAR_TV
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinearOfferRow',
  props: {
    title: null,
    offers: null,
    inline: { type: Boolean },
    trackingContexts: { default: () => [] },
    isLinearTVExp: { type: Boolean },
    linearOffers: null,
    isBannerBuyBox: { type: Boolean }
  },
  emits: ["clickOut"],
  setup(__props: any) {





return { __sfc: true,OfferRow, LinearOffer, LinearOfferExp }
}

})